<template>
	<el-drawer title="无样开播" :visible.sync="visible" class="apply-sample-drawer" :before-close="handleClose" size="1000px" :wrapperClosable="false">
		<!-- 抽屉内容 -->
		<div class="content" v-if="visible">
			<!-- 选择合作对象 -->
			<div class="bgcf">
				<ChooseCooPartner
					class="choose-coo-partner"
					:isTalent="isTalent"
					:isBatch="isCooPartnerBatch"
					ref="chooseCooPartner"
					@gutCopartner="gutCopartner"
					:chooseAnchorList="chooseAnchorList"
					@getList="getList($event)"
					:platformId="platformId"
				></ChooseCooPartner>
			</div>

			<!-- 确认合作商品 -->
			<div class="bgcf">
				<ConfirmCooGoods
					ref="confirmCooGoods"
					:isBatch="isBatch"
					class="confirm-coo-goods"
					:platformId="platformId"
					:chooseGoodsList="chooseGoodsList"
					:total="total"
					@checkSelectGoods="checkSelectGoods"
				></ConfirmCooGoods>
			</div>

			<div style="height: 38px"></div>
		</div>
		<!-- 底部按钮组 -->
		<div class="footer yx-background-white">
			<el-button @click="handleClose">取消</el-button>
			<el-button type="primary" @click="confirm" :disabled="isDisable" :loading="loading">确认</el-button>
		</div>
		<batchHintDialog ref="batchHintDialog" @confirmBroadcast="confirmBroadcast" />
	</el-drawer>
</template>
<script>
import debounce from 'lodash/debounce';
import {
	batchBroadcastingWithoutSamples,
	drDuplicateCooperationVerification,
	getProductSkuList,
	tzDuplicateCooperationVerification,
} from '@/api/shopManage';
import { talentList } from '@/api/extenTecord';
import ConfirmCooGoods from './components/confirmCooGoods';
import ChooseCooPartner from './components/chooseCooPartner';
import batchHintDialog from './components/errorDialog/batchHintDialog.vue';
export default {
	name: 'SampleFreeBroadcastDrawer',
	components: {
		ChooseCooPartner,
		ConfirmCooGoods,
		batchHintDialog,
	},
	props: {
		platformId: {
			type: [Number, String],
			default: dataMap.PLATFORM_DY.value,
		},
		fromPage: {
			type: String,
			default: 'shopLibrary', // shopLibrary 商品库 talent 我的达人
		},
	},
	data() {
		return {
			visible: false, // 抽屉显隐
			mode: 'fast', // 商品选择模式，fast为单个商品快速申样，multiple为多个商品批量申样
			talentMode: 'multiple', // 达人选择模式，fast为单个达人快速申样，multiple为多个达人批量申样
			goods: [], // 申样商品
			retail_type: '0', // 合作对象默认达人
			productIds: [],
			total: 0,
			chooseGoodsList: [],
			chooseAnchorList: [],
			appointParams: {},
			anchorObj: {},
			selectGoodsFlag: false,
			loading: false,
			anchor_ids: [],
			anchor_list: [],
			productList: [],
			anchorIds: [],
			selectionShopArr: [],
		};
	},
	computed: {
		// 达人是否支持批量
		isCooPartnerBatch({ talentMode }) {
			return talentMode === 'multiple';
		},
		isBatch({ mode }) {
			return mode === 'multiple';
		},
		isDisable({ anchorObj, selectGoodsFlag }) {
			return !(anchorObj.isChecked && selectGoodsFlag);
		},
		isShopLibrary({ fromPage }) {
			return fromPage === 'shopLibrary';
		},
		isTalent({ fromPage }) {
			return fromPage === 'talent';
		},
	},
	methods: {
		gutCopartner(val) {
			this.retail_type = val;
		},
		show(selectionShopArr, mode = 'multiple', talentMode = 'multiple') {
			if (!['fast', 'multiple'].includes(mode)) {
				throw new Error('无样开播组件模式只能为fast或者mutilple');
			}
			this.selectionShopArr = selectionShopArr;
			const ids = selectionShopArr.map(item => item.product_id);
			this.mode = mode;
			this.talentMode = talentMode;
			// 初始化选择达人
			if (this.isTalent) {
				this.anchorIds = ids;
				this.getTalentList();
			} else {
				// 初始化选择商品
				this.productIds = ids;
				this.getSkuList();
			}
			this.visible = true;
			this.retail_type = '0';
		},
		async getTalentList() {
			const { platformId, anchorIds } = this;
			let { data } = await talentList({
				page_index: 1,
				page_size: 20,
				platform_id: platformId,
				anchor_ids: anchorIds.join(','),
			});
			this.chooseAnchorList = data.list;
			this.visible = true;
		},
		async getSkuList() {
			const { platformId, productIds } = this;
			const list = await getProductSkuList({ platformId, productIds });
			// this.chooseGoodsList = list;
			// 数组去重
			let arr = [
				...list.map(item => {
					return {
						...item,
						hasSku: true,
					};
				}),
				...this.selectionShopArr.map(item => {
					return {
						productName: item.product_name,
						productPic: item.product_pic,
						shopName: item.shop_name,
						productId: item.product_id,
						thirdProductId: item.third_product_id,
						id: '',
						onlyId: '',
						price: item.sale_price,
						skuId: '',
						sourceType: '',
						sourceTypeDesc: '',
						specification: '',
						spuPrice: item.sale_price,
						stockNum: '',
						hasSku: false,
					};
				}),
			];
			let map = new Map();
			for (let item of arr) {
				if (!map.has(item.productId)) {
					map.set(item.productId, item);
				}
			}
			this.chooseGoodsList = [...map.values()];
			this.visible = true;
		},
		checkSelectGoods(e) {
			this.selectGoodsFlag = e;
		},
		getList(params) {
			this.anchorObj = params;
		},
		colse() {
			this.anchorIds = [];
			this.chooseAnchorList = [];
			this.$refs.chooseCooPartner.reset();
			this.$refs.confirmCooGoods.reset();
			this.visible = false;
		},
		handleClose() {
			this.colse();
		},
		confirm: debounce(async function () {
			this.loading = true;
			const goodsSpuObj = this.$refs.confirmCooGoods.getSelectList();
			this.productList = Object.keys(goodsSpuObj).map(productId => {
				return productId;
			});
			this.anchor_ids = this.anchorObj.anchor_list.map(obj => obj.anchor_id);
			this.anchor_list = this.anchorObj.anchor_list;
			this.sampleFreeApiGroup();
		}, 1000),
		sampleFreeApiGroup() {
			const { platformId: platform_id, anchor_ids, retail_type, anchor_list, productList: product_ids } = this;
			try {
				this.handleCooperationVerification({ product_ids, anchor_ids, retail_type, anchor_list, platform_id });
				this.loading = false;
			} catch (e) {
				this.loading = false;
			}
		},
		async handleCooperationVerification({ product_ids, anchor_list, retail_type, platform_id, anchor_ids }) {
			if (this.retail_type == 0) {
				const { data } = await drDuplicateCooperationVerification({ product_ids, anchor_ids, platform_id, retail_type });
				this.handleDuplicate({ product_ids, anchor_list, platform_id, retail_type, data });
			} else if (this.retail_type == 1) {
				const { data } = await tzDuplicateCooperationVerification({ product_ids, anchor_list, platform_id });
				this.handleDuplicate({
					product_ids,
					anchor_list,
					platform_id,
					retail_type,
					data: { check_status: data.status, list: data.list },
				});
			}
		},

		handleDuplicate({ product_ids, anchor_list, platform_id, retail_type, data }) {
			switch (data.check_status) {
				case 0: // 0校验通过
					this.confirmBroadcast({ product_ids, anchor_list, platform_id, retail_type });
					this.loading = false;
					break;
				case 1: // 1根据[商品id+团长id+达人]有合作进度，不可继续操作
					this.$refs.batchHintDialog.show(data.list, data.check_status);
					this.loading = false;
					break;
				case 2: // 2根据商品+达人有在途合作进度，弹窗提示，可继续开播
					this.$refs.batchHintDialog.show(data.list, data.check_status);
					this.loading = false;
					break;
				default:
					// 处理其他情况
					break;
			}
		},
		async confirmBroadcast() {
			const { platformId: platform_id, retail_type, anchor_list, productList: product_ids } = this;
			await batchBroadcastingWithoutSamples({ product_ids, anchor_list, platform_id, retail_type });
			this.$message({ type: 'success', message: '无样开播成功！', offset: 50 });
			this.$emit('refreshList');
			this.handleClose();
		},
	},
};
</script>
<style lang="less" scoped>
.apply-sample-drawer {
	.content {
		min-height: 100%;
		position: relative;
		padding: 16px 20px 16px 20px;
		background-color: #f7f8fa;
		.bgcf {
			height: 100%;
			padding: 20px 20px;
			background-color: @color-white;
			border-radius: 8px;
			margin-bottom: 16px;
		}
	}
	.footer {
		position: absolute;
		width: 100%;
		bottom: 0;
		padding: 10px;
		display: flex;
		justify-content: flex-end;
		border-top: 1px solid #f0f1f5;
		box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
		z-index: 999;
	}
	/deep/ .el-table__empty-block {
		display: none;
	}
}
</style>
